import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  Output,
  EventEmitter
} from '@angular/core';
import { PanelOptionsService } from '@shared/services/pre-order/panel-options/panel-options.service';
import { PreOrderDetailsService } from '@shared/api/steps/pre-order-details/pre-order-details.service';
import { SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import { PromoDiscountService } from '@shared/api/promo-discount/promo-discount.service';
import { UrlQueryStringService } from '@shared/services/url-query-string/url-query-string.service';
import { ActivatedRoute } from '@angular/router';
import { ViewportService } from '@shared/services/viewport/viewport.service';

@Component({
  selector: 'panel-options',
  templateUrl: './panel-options.component.html',
  styleUrls: ['./panel-options.component.scss']
})
export class PanelOptionsComponent implements OnInit, AfterViewInit {
  openPreOrderDetails = false;
  isMobile;
  isCommittingFunds = false;
  numberOfPartsOption;
  selectedNumberOfParts = 0;
  paymentMethodOptions;
  commitmentAmount = 0;
  pricePerParts = 0;
  selectedPaymentMethod;
  selectButtonStatus = [
    { id: 1, name: `isNumberOfPartsOpen`, status: false },
    { id: 2, name: `isPaymentMethodOpen`, status: false }
  ];
  isEAC = false;
  canAvailPromoDiscount = false;
  promoDiscountMessage = '';
  propertyId;

  @Output() validPanelOption = new EventEmitter<any>();

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
    }, 250);
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _panelOptionsService: PanelOptionsService,
    private _promoDiscountService: PromoDiscountService,
    private _urlQueryStringService: UrlQueryStringService,
    private activatedRoute: ActivatedRoute,
    private _viewportService: ViewportService
  ) {
    this.numberOfPartsOption = this._panelOptionsService.getNumberOfPartsOption();
    this.pricePerParts = this._panelOptionsService.getPricePerPart();
    this._viewportService.updatingView.subscribe(() => {
      this.isMobile = this._viewportService.isMobile();
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.paymentMethodOptions = this._panelOptionsService.getPaymentMethods();
    this.selectedPaymentMethod = this._panelOptionsService.getDefaultMethod();
    this.isEAC = parseInt(this._urlQueryStringService.getEAC(), 10) === 1;
    this.propertyId = parseInt(this.activatedRoute.snapshot.params.id, 10);
  }

  ngAfterViewInit() {
    this._viewportService.checkViewSizes();
  }

  updateNumberOfParts(value) {
    this.selectedNumberOfParts = value;
    this.commitmentAmount = this.selectedNumberOfParts * this.pricePerParts;
    this.commitmentAmount = parseFloat(this.commitmentAmount.toFixed(2));
    this._panelOptionsService.setCommitmentAmount(this.commitmentAmount);
    this._panelOptionsService.setSelectedNumberOfParts(
      this.selectedNumberOfParts
    );
    this.isValidFields();
    const promoCode = this._urlQueryStringService.getPromoDiscount();
    if (!!promoCode) {
      this._promoDiscountService
        .promoDiscountChecker(promoCode, {
          propertyId: this.propertyId,
          noOfParts: this.selectedNumberOfParts
        })
        .subscribe(res => {
          this.canAvailPromoDiscount = res.canAvail;
          this.promoDiscountMessage = res.promoMessage;
        });
    }
  }

  isValidFields() {
    this.validPanelOption.emit(
      !!this.selectedNumberOfParts && this.isCommittingFunds
    );
  }

  setSelectedMethod(method) {
    this.selectedPaymentMethod = method;
    this._panelOptionsService.setSelectedMethod(this.selectedPaymentMethod);
  }

  setSelectButtonStatus(id, status) {
    this.selectButtonStatus = this.selectButtonStatus.map(selectButton => {
      if (selectButton.id === id) {
        selectButton.status = status;
      } else {
        selectButton.status = false;
      }
      return selectButton;
    });
  }
}
